import { useMemo } from "react";
import {
  CONTENT_CATEGORY_TYPE,
  CONTENT_SECTOR_TYPE,
  CONTENT_STORE_TYPE,
  ContentCategoryType,
  ContentSectorType,
  ContentStoreType,
  STORE_OPEN,
  WebStoreSelectorType,
} from "../../controller/MasterController";
import { ThemeType } from "../../recoil/theme";
import { contentName } from "../../utils/util";
import CategoryContent from "./content/categoryContent";
import StoreContent from "./content/storeContent";

interface StoreListProps {
  storeList: WebStoreSelectorType | undefined;
  lang: number;
  currentDate: Date;
  navigateSector: any;
  theme: ThemeType;
}

const StoreContents = ({
  storeList,
  lang,
  currentDate,
  navigateSector,
  theme,
}: StoreListProps) => {
  const StoreContents = useMemo(() => {
    return (
      <>
        {storeList?.main_section?.map?.((main, index) => {
          const filteredContent = Array.isArray(main?.content)
            ? (main.content.filter(
                (sector) =>
                  sector.content_type === CONTENT_SECTOR_TYPE && sector.data
              ) as ContentSectorType[])
            : [];

          const AllStoreList = filteredContent
            .flatMap((store) => store.data.store_list ?? [])
            .sort((a, b) => {
              const aOpen = a.store_availability === STORE_OPEN;
              const bOpen = b.store_availability === STORE_OPEN;

              if (aOpen && !bOpen) return -1;
              if (!aOpen && bOpen) return 1;
              return 0;
            });

          return (
            <div key={index} className="centerWrap">
              <div className="deliveryTitle">
                <div className="row">
                  <h2>{contentName("배달맛집", lang)}</h2>
                  {theme.store_list && (
                    <img src={theme.store_list} alt="sock" />
                  )}
                </div>
              </div>
              <div className="normalStoreWrap">
                {AllStoreList.map((store, storeIndex) => (
                  <StoreContent
                    key={storeIndex}
                    item={{
                      content_type: CONTENT_STORE_TYPE,
                      data: store,
                    }}
                    currentDate={currentDate}
                    navigateSector={navigateSector}
                    type={"main"}
                  />
                ))}
                {main?.content?.map((group, index) =>
                  group.content_type === CONTENT_STORE_TYPE ? (
                    <StoreContent
                      key={index}
                      item={group as ContentStoreType}
                      currentDate={currentDate}
                      navigateSector={navigateSector}
                      type={"main"}
                    />
                  ) : (
                    group.content_type === CONTENT_CATEGORY_TYPE && (
                      <CategoryContent
                        key={index}
                        item={group as ContentCategoryType}
                        navigateSector={navigateSector}
                      />
                    )
                  )
                )}
              </div>
            </div>
          );
        }) ?? null}
      </>
    );
  }, [storeList, lang, currentDate]);

  return StoreContents;
};
export default StoreContents;
